import cn from 'classnames';
import React from 'react';
import { toTitleCase } from '../../../Lib/String';
import './Label.scss';

export type LabelProps = Pick<
  React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>,
  'htmlFor' | 'style' | 'className'
> & {
  emph?: boolean;
  visible?: boolean;
  noRecase?: boolean;
};

const Label: React.FC<React.PropsWithChildren<LabelProps>> = ({
  children,
  className,
  emph,
  htmlFor,
  style,
  visible = true,
  noRecase = false,
}) => {
  const internalClassname = cn('Label', { 'Label-emph': emph });

  if (typeof children === 'string' && !noRecase) {
    children = toTitleCase(children);
  }
  return !visible ? null : (
    <label className={`${internalClassname} ${className}`} htmlFor={htmlFor} style={style}>
      {children}
    </label>
  );
};

export { Label };
export default Label;
